import { type Subdivision } from '@wix/locale-dataset-data';

export const mapSubdivisionReplacedBy = (
  subdivisions: Subdivision[],
  countryCode: string,
) => {
  return subdivisions.reduce<Subdivision[]>((acc, item) => {
    const alreadyExists = acc.some(
      (subdivision) =>
        subdivision.key === item.replacedBy || subdivision.key === item.key,
    );
    if (alreadyExists) {
      return acc;
    }

    if (item.replacedBy === undefined) {
      acc.push({
        displayName: `locale-dataset.states.${countryCode}.${item.key}`,
        key: item.key,
      });
      return acc;
    }

    acc.push({
      displayName: `locale-dataset.states.${countryCode}.${
        item.replacedBy || item.key
      }`,
      key: item.replacedBy || item.key,
    });
    return acc;
  }, []);
};
